import { useEffect } from 'react';
import { useRouteMatch, useLocation, useHistory } from 'react-router';

import * as couponCookie from './utils/couponCookie';

import {
  PATH_COUPON_CODE_MATCH,
  USER_REFERRER_QUERY_PARAM,
  COUPON_CODE_QUERY_PARAM,
  COUPON_COOKIE_VERSION,
} from './constants';

import { ReferrerType } from './types';
import { isValidCouponMatch } from './utils/couponMatch';
import { sanitizeCouponCode } from './utils/sanitize';

export function useSetCouponCookie() {
  const match = useRouteMatch(PATH_COUPON_CODE_MATCH);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    if (isValidCouponMatch(match?.params)) {
      couponCookie.set({
        referrerAssociatedAt: new Date(),
        referrerCode: sanitizeCouponCode(match?.params.couponCode),
        referrerType: ReferrerType.Partner,
        version: COUPON_COOKIE_VERSION,
      });

      history.replace({
        ...location,
        pathname: '/',
      });
    }
  }, [match, history, location]);

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const couponCode = query.get(COUPON_CODE_QUERY_PARAM);
    const referrer = query.get(USER_REFERRER_QUERY_PARAM);

    if (couponCode) {
      couponCookie.set({
        referrerAssociatedAt: new Date(),
        referrerCode: sanitizeCouponCode(couponCode),
        referrerType: ReferrerType.Partner,
        version: COUPON_COOKIE_VERSION,
      });

      query.delete(COUPON_CODE_QUERY_PARAM);

      history.replace({
        ...location,
        search: query.toString(),
      });

      return;
    }

    if (referrer) {
      couponCookie.set({
        referrerAssociatedAt: new Date(),
        referrerCode: sanitizeCouponCode(referrer),
        referrerType: ReferrerType.User,
        version: COUPON_COOKIE_VERSION,
      });

      query.delete(USER_REFERRER_QUERY_PARAM);

      history.replace({
        ...location,
        search: query.toString(),
      });

      return;
    }
  }, [match, history, location]);
}
